export const FIELD_REMOVED = 'app/components/SubForm/FIELD_REMOVED';
